import { createContext, useContext } from 'react';
import type { Suggestion } from '../types';

export const SuggestionContext = createContext<Suggestion | undefined>(undefined);

export const useSuggest = () => useContext(SuggestionContext);
